/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `wenn Sie nicht finden, was Sie suchen.`
};

const en_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `if you can't find what you're looking for.`
};

const es_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `si no encuentras lo que buscas.`
};

const fr_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `si vous ne trouvez pas ce que vous cherchez.`
};

const it_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `se non riesci a trovare quello che stai cercando.`
};

const nl_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `indien u niet vindt wat u zoekt.`
};

const pt_error__404__text_end = /** @type {(inputs: {}) => string} */ () => {
	return `se não conseguir encontrar o que procura.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_end = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__404__text_end(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__404__text_end", locale)
	if (locale === "de") return de_error__404__text_end(inputs)
	if (locale === "en") return en_error__404__text_end(inputs)
	if (locale === "es") return es_error__404__text_end(inputs)
	if (locale === "fr") return fr_error__404__text_end(inputs)
	if (locale === "it") return it_error__404__text_end(inputs)
	if (locale === "nl") return nl_error__404__text_end(inputs)
	return pt_error__404__text_end(inputs)
};